import React from 'react'
import { useState } from 'react'
import { Card, Button, Heading } from '@enterprise-ui/canvas-ui-react'
import { useNavigate } from 'react-router'
import { useToaster } from '@enterprise-ui/canvas-ui-react'
import { VendorContext } from '../../globalState/Vendor'
import { downloadSavedView } from '../../services/requests'
import fileDownload from 'js-file-download'
import { TOASTER_DEFAULTS } from '../../globalConfig/constants'

export const SavedViewsHomePageCard = ({ savedViews }) => {
  const navigate = useNavigate()
  const makeToast = useToaster()
  const [loadingSavedViews, setLoadingSavedViews] = useState([])
  const [vendorState] = React.useContext(VendorContext)
  const bodyText =
    "Saved Views allows you to save any particular set of search criteria that you've applied to the Cost Search page so that you can quickly revisit it in the future."

  const makeDownloadSavedViewRequest = (savedView, index) => {
    setLoadingSavedViews((oldArray) => [...oldArray, index])
    downloadSavedView(savedView.viewId, vendorState?.selectedVendor)
      .then((response) => {
        setLoadingSavedViews((oldArray) =>
          oldArray.filter((value) => value !== index),
        )
        if (response?.status === 200) {
          const fileName = `${
            savedView?.title
          } ${new Date().toLocaleString()}.xlsx`
            .replaceAll('/', '-')
            .replaceAll(':', '_')
          fileDownload(response.data, fileName)
          makeToast({
            ...TOASTER_DEFAULTS,
            type: 'success',
            heading: 'Download Successful',
            message: `"${fileName}" successfully downloaded`,
          })
        } else {
          makeToast({
            ...TOASTER_DEFAULTS,
            type: 'error',
            heading: 'Download Failed',
            message: 'Failed to download your saved view.',
          })
        }
      })
      .catch(() => {
        setLoadingSavedViews((oldArray) =>
          oldArray.filter((value) => value !== index),
        )
        makeToast({
          ...TOASTER_DEFAULTS,
          type: 'error',
          heading: 'Download Failed',
          message: 'Failed to download your saved view.',
        })
      })
  }

  return (
    <Card
      className="hc-pa-normal hesp-homepage-card"
      style={{ minWidth: '500px' }}
      data-testid={`homepage-card-Saved Views`}
    >
      <div className="hesp-general-flex hesp-homepage-card-inner">
        <Heading size={3}>Saved Views</Heading>
        <p className="hc-mt-xs">{`${bodyText}${savedViews?.length ? ' You can see all of your currently saved views below:' : ''}`}</p>
        {savedViews?.length ? (
          <div
            className="hesp-general-flex"
            style={{
              flexDirection: 'column',
              maxHeight: '200px',
              overflowY: 'scroll',
              gap: '12px',
            }}
          >
            {savedViews.map((viewDetails, index) => {
              return (
                <div
                  className="hesp-general-flex hesp-general-alignItemsCenter"
                  key={`savedViewCardRow${index}`}
                >
                  <span className="hc-mr-normal hesp-general-flex-grow">
                    <strong>{viewDetails?.title}</strong>
                  </span>
                  <Button
                    className="hc-mr-normal hesp-homepage-savedViewsCard-viewButton"
                    data-testid={`homepage-card-${viewDetails?.title}-viewButton`}
                    onClick={() =>
                      navigate(`/saved-view/${viewDetails?.viewId}`)
                    }
                    type="secondary"
                  >
                    VIEW / EDIT
                  </Button>
                  <Button
                    className="hesp-homepage-savedViewsCard-downloadButton"
                    data-testid={`homepage-card-${viewDetails?.title}-downloadButton`}
                    isLoading={loadingSavedViews.includes(index)}
                    onClick={() =>
                      makeDownloadSavedViewRequest(viewDetails, index)
                    }
                    type="primary"
                  >
                    DOWNLOAD RESULTS
                  </Button>
                </div>
              )
            })}
          </div>
        ) : (
          <div
            className="hesp-homepage-card-button-container"
            style={{ flexDirection: 'column', gap: '5px' }}
          >
            <p className="hc-mb-none hesp-general-centeredText">
              You haven't saved any views yet, go to
            </p>
            <Button onClick={() => navigate('/cost-search')} type="primary">
              COST SEARCH
            </Button>
            <p className="hesp-general-centeredText">
              to start creating views to save.
            </p>
          </div>
        )}
      </div>
    </Card>
  )
}
